import { BrandProgressBar } from '@/components/BrandLoader';
import { cn } from '@/lib/cn';

/**
 * JEDYNY wskaznik ladowania w srodku aplikacji (Dawid 2026-09-30: „trzy albo cztery
 * typy ladowania — ujednolicic”). Zasada:
 *  - start aplikacji / wylogowanie → `BrandLoader` (logo + pasek),
 *  - strona, zakladka, sekcja, okno, lista → `<Loading />` (ten sam pasek marki),
 *  - akcja w przycisku → `Button loading` (maly wskaznik w przycisku).
 * Zadnych innych krecacych sie kolek ani szarych pulsujacych blokow.
 */
export function Loading({
  size = 'section',
  label = 'Ładowanie…',
  className,
}: {
  /** page — cala strona/zakladka; section — karta, okno, lista; inline — w linii tekstu. */
  size?: 'page' | 'section' | 'inline';
  /** Dla czytnikow ekranu (niewidoczne). */
  label?: string;
  className?: string;
}) {
  if (size === 'inline') {
    return (
      <span role="status" className={cn('inline-flex w-10 align-middle', className)}>
        <BrandProgressBar className="h-1" />
        <span className="sr-only">{label}</span>
      </span>
    );
  }
  return (
    <div
      role="status"
      className={cn(
        'flex items-center justify-center',
        size === 'page' ? 'py-20' : 'py-10',
        className,
      )}
    >
      <BrandProgressBar className={size === 'page' ? 'w-48' : 'w-32'} />
      <span className="sr-only">{label}</span>
    </div>
  );
}
